import React, { useMemo } from "react";
import { FloatingTechIcon } from "./FloatingTechIcon";
import { TechIconName } from "./types";
import {
  generateRandomIcons,
  generateIconPosition,
  generateIconAnimation,
  generateIconTransition,
} from "./utils";

interface RandomFloatingIconsProps {
  theme: "light" | "dark";
  icons: TechIconName[];
  count?: number;
}

export const RandomFloatingIcons: React.FC<RandomFloatingIconsProps> = ({
  theme,
  icons,
  count = 3,
}) => {
  const randomIcons = useMemo(
    () => generateRandomIcons(icons, count),
    [icons, count],
  );

  return (
    <>
      {randomIcons.map((config, index) => {
        const position = generateIconPosition(config.position);
        const animation = generateIconAnimation(index);
        const transition = generateIconTransition(index);

        return (
          <FloatingTechIcon
            key={`${config.icon}-${index}`}
            theme={theme}
            icon={config.icon}
            size={config.size || "65px"}
            top={position.top}
            left={position.left}
            animate={animation}
            transition={transition}
          />
        );
      })}
    </>
  );
};
